import { createAction } from '@reduxjs/toolkit';
import {
    IGetTalentReviews,
    types,
    ICreateWorkProfile,
    IUpdateWorkProfile,
    ICreateTalentReview,
    IUpdateTalentReview,
    ILikeDislikeReview,
    IAddCredit,
} from './types';
import { IGenericDocumentModifier, IPastWork, IWorkProfile } from '../../types/global/helper';
import { IErrorType } from '../../constants/types';

export const getCurrentUserTalentProfile = createAction(types.GET_CURRENT_USER_TALENT_PROFILE);
export const getCurrentUserTalentProfileSuccess = createAction<IWorkProfile[]>(
    types.GET_CURRENT_USER_TALENT_PROFILE_SUCCESS,
);
export const getCurrentUserTalentProfileFail = createAction<IErrorType>(types.GET_CURRENT_USER_TALENT_PROFILE_FAIL);

export const getTalentProfileDetails = createAction<string>(types.GET_TALENT_PROFILE_DETAILS);
export const getTalentProfileDetailsSuccess = createAction<IWorkProfile[]>(types.GET_TALENT_PROFILE_DETAILS_SUCCESS);
export const getTalentProfileDetailsFail = createAction<IErrorType>(types.GET_TALENT_PROFILE_DETAILS_FAIL);

export const getAllTalentProfile = createAction<any>(types.GET_ALL_TALENT_PROFILES);
export const getAllTalentProfileSuccess = createAction<any>(types.GET_ALL_TALENT_PROFILES_SUCCESS);
export const getAllTalentProfileFail = createAction<any>(types.GET_ALL_TALENT_PROFILES_FAIL);

export const createTalentProfile = createAction<ICreateWorkProfile>(types.CREATE_TALENT_PROFILE);
export const createTalentProfileSuccess = createAction<IWorkProfile>(types.CREATE_TALENT_PROFILE_SUCCESS);
export const createTalentProfileFail = createAction<IErrorType>(types.CREATE_TALENT_PROFILE_FAIL);

export const updateTalentProfile = createAction<IUpdateWorkProfile>(types.UPDATE_TALENT_PROFILE);
export const updateTalentProfileSuccess = createAction<IWorkProfile>(types.UPDATE_TALENT_PROFILE_SUCCESS);
export const updateTalentProfileFail = createAction<IErrorType>(types.UPDATE_TALENT_PROFILE_FAIL);

export const publishTalentProfile = createAction<IGenericDocumentModifier>(types.PUBLISH_TALENT_PROFILE);
export const publishTalentProfileSuccess = createAction<IWorkProfile>(types.PUBLISH_TALENT_PROFILE_SUCCESS);
export const publishTalentProfileFail = createAction<IErrorType>(types.PUBLISH_TALENT_PROFILE_FAIL);

export const unPublishTalentProfile = createAction<IGenericDocumentModifier>(types.UNPUBLISH_TALENT_PROFILE);
export const unPublishTalentProfileSuccess = createAction<IWorkProfile>(types.UNPUBLISH_TALENT_PROFILE_SUCCESS);
export const unPublishTalentProfileFail = createAction<IErrorType>(types.UNPUBLISH_TALENT_PROFILE_FAIL);

export const deleteTalentProfile = createAction<IGenericDocumentModifier>(types.DELETE_TALENT_PROFILE);
export const deleteTalentProfileSuccess = createAction<IGenericDocumentModifier>(types.DELETE_TALENT_PROFILE_SUCCESS);
export const deleteTalentProfileFail = createAction<IErrorType>(types.DELETE_TALENT_PROFILE_FAIL);

export const deleteSingleImage = createAction<any>(types.DELETE_SINGLE_TALENT_IMAGE);
export const deleteSingleImageSuccess = createAction<any>(types.DELETE_SINGLE_TALENT_IMAGE_SUCCESS);
export const deleteSingleImageFail = createAction<any>(types.DELETE_SINGLE_TALENT_IMAGE_FAIL);

export const deleteSingleImageFromGallery = createAction<any>(types.DELETE_SINGLE_IMAGE_FROM_TALENT__GALLERY);
export const deleteSingleImageFromGallerySuccess = createAction<any>(
    types.DELETE_SINGLE_IMAGE_FROM_TALENT__GALLERY_SUCCESS,
);
export const deleteSingleImageFromGalleryFail = createAction<any>(types.DELETE_SINGLE_IMAGE_FROM_TALENT__GALLERY_FAIL);

export const uploadImage = createAction<any>(types.UPLOAD_IMAGE);
export const uploadImageSuccess = createAction<any>(types.UPLOAD_IMAGE_SUCCESS);
export const uploadImageFail = createAction<any>(types.UPLOAD_IMAGE_FAIL);

export const getTalentPastWork = createAction<any>(types.GET_TALENT_PAST_WORK);
export const getTalentPastWorkSuccess = createAction<any>(types.GET_TALENT_PAST_WORK_SUCCESS);
export const getTalentPastWorkFail = createAction<any>(types.GET_TALENT_PAST_WORK_FAIL);

export const setProfileForEdit = createAction<any>(types.SET_PROFILE_FOR_EDIT);
export const addTalentFilter = createAction<any>(types.ADD_TALENT_FILTER);
export const removeTalentFilter = createAction<any>(types.REMOVE_TALENT_FILTER);
export const toggleFilter = createAction(types.TOGGLE_TALENT_FILTER);
export const filterTalent = createAction<any>(types.FILTER_TALENT);

export const getDiscover = createAction(types.GET_DISCOVER);
export const getDiscoverSuccess = createAction<any>(types.GET_DISCOVER_SUCCESS);
export const getDiscoverFail = createAction<any>(types.GET_DISCOVER_FAIL);

export const getActs = createAction(types.GET_ACTS);
export const getActsSuccess = createAction<any>(types.GET_ACTS_SUCCESS);
export const getActsFail = createAction<any>(types.GET_ACTS_FAIL);

export const getSingleAct = createAction(types.GET_SINGLE_ACT);
export const getSingleActSuccess = createAction<any>(types.GET_SINGLE_ACT_SUCCESS);
export const getSingleActFail = createAction<any>(types.GET_SINGLE_ACT_FAIL);

export const getMyActs = createAction(types.GET_MY_ACTS);
export const getMyActsSuccess = createAction<any>(types.GET_MY_ACTS_SUCCESS);
export const getMyActsFail = createAction<any>(types.GET_MY_ACTS_FAIL);

export const createAct = createAction<any>(types.CREATE_ACT);
export const createActSuccess = createAction<any>(types.CREATE_ACT_SUCCESS);
export const createActFail = createAction<any>(types.CREATE_ACT_FAIL);

export const deleteAct = createAction<any>(types.DELETE_ACT);
export const deleteActSuccess = createAction<any>(types.DELETE_ACT_SUCCESS);
export const deleteActFail = createAction<any>(types.DELETE_ACT_FAIL);

export const setTalentDetails = createAction<any>(types.SET_TALENT_DETAILS);
export const resetTalentProfile = createAction(types.RESET_TALENT_PROFILE);

export const getTalentReviews = createAction<IGetTalentReviews>(types.GET_TALENT_REVIEWS);
export const getTalentReviewsSuccess = createAction<any>(types.GET_TALENT_REVIEWS_SUCCESS);
export const getTalentReviewsFail = createAction<any>(types.GET_TALENT_REVIEWS_FAIL);

export const createTalentReview = createAction<ICreateTalentReview>(types.CREATE_TALENT_REVIEW);
export const createTalentReviewSuccess = createAction<any>(types.CREATE_TALENT_REVIEW_SUCCESS);
export const createTalentReviewFail = createAction<any>(types.CREATE_TALENT_REVIEW_FAIL);

export const updateTalentReview = createAction<IUpdateTalentReview>(types.UPDATE_TALENT_REVIEW);
export const updateTalentReviewSuccess = createAction<any>(types.UPDATE_TALENT_REVIEW_SUCCESS);
export const updateTalentReviewFail = createAction<any>(types.UPDATE_TALENT_REVIEW_FAIL);

export const deleteTalentReview = createAction<string>(types.DELETE_TALENT_REVIEW);
export const deleteTalentReviewSuccess = createAction<string>(types.DELETE_TALENT_REVIEW_SUCCESS);
export const deleteTalentReviewFail = createAction<any>(types.DELETE_TALENT_REVIEW_FAIL);

export const likeTalentReview = createAction<ILikeDislikeReview>(types.LIKE_TALENT_REVIEW);
export const likeTalentReviewSuccess = createAction<any>(types.LIKE_TALENT_REVIEW_SUCCESS);
export const likeTalentReviewFail = createAction<any>(types.LIKE_TALENT_REVIEW_FAIL);

export const dislikeTalentReview = createAction<ILikeDislikeReview>(types.DISLIKE_TALENT_REVIEW);
export const dislikeTalentReviewSuccess = createAction<any>(types.DISLIKE_TALENT_REVIEW_SUCCESS);
export const dislikeTalentReviewFail = createAction<any>(types.DISLIKE_TALENT_REVIEW_FAIL);

export const addCredit = createAction<IAddCredit>(types.ADD_CREDIT);
export const addCreditSuccess = createAction<IPastWork>(types.ADD_CREDIT_SUCCESS);
export const addCreditFail = createAction<IErrorType>(types.ADD_CREDIT_FAIL);

export const updateCredit = createAction<IGenericDocumentModifier>(types.UPDATE_CREDIT);
export const updateCreditSuccess = createAction<IPastWork>(types.UPDATE_CREDIT_SUCCESS);
export const updateCreditFail = createAction<IErrorType>(types.UPDATE_CREDIT_FAIL);

export const deleteCredit = createAction<IGenericDocumentModifier>(types.DELETE_CREDIT);
export const deleteCreditSuccess = createAction<IGenericDocumentModifier>(types.DELETE_CREDIT_SUCCESS);
export const deleteCreditFail = createAction<IErrorType>(types.DELETE_CREDIT_FAIL);
